import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_ConsentToTeleMentalHealth = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_ConsentToTeleMentalHealth' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <b>Introduction</b>  <br /> 
                    Tele-mental health is the form of telemedicine that allows clients to access mental health care using audio-video interface
                    such as videoconferencing. <br />
                    Electronic systems used will incorporate network and software security protocols to protect the confidentiality of client
                    identification and imaging data and will include measures to safeguard the data and to ensure its integrity against
                    intentional or unintentional corruption. <br />  <br />
                    <b>Expected Benefits:</b>   <br />
                    <b>1. </b> Improved access to mental health care by enabling a client to remain in his/her home or office.<br />
                    <b>2. </b> Improved convenience for the client.<br />
                    <b>3. </b> More efficient management of mental health care within the community setting.<br />
                    <b>4. </b> Obtaining expertise of a distant specialist.<br /> <br />
                    <b>Possible Risks: </b>  <br />
                    As with any medical procedure, there are potential risks associated with the use of tele-mental health. These risks include,
                    but may not be limited to:<br />
                    <b>1. </b> In rare cases, information transmitted may not be sufficient (e.g. poor resolution of images) to allow for the
                    effective communication between the client and the mental health professional. Effective communication is vital
                    to the provision of mental health services by the mental health professional;<br />
                    <b>2. </b> Cultural and/or language differences between the client and the mental health professional may affect
                    communication and service delivery.<br />
                    <b>3.  </b> Delays in mental health assessment and treatment could occur due to deficiencies or failures of the
                    equipment;<br />
                    <b>4. </b> In very rare instances, security protocols could fail, causing a breach of privacy of personal medical information;<br />
                    <b>5. </b> In rare cases, a lack of access to complete medical records may result in judgmental errors by the mental health
                    professional;<br /> <br />
                    <b>Please initial after reading this page:</b>
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    By signing this form, I understand the following: <br />
                    <b>1.</b>  I understand that the laws that protect privacy and the confidentiality of medical information also apply to telemental health and that no information obtained in the use of tele-therapy which identifies me will be disclosed to
                    researchers or other entities without my consent.<br />
                    <b>2.</b> I understand that I have the right to withhold or withdraw my consent to the use of tele-mental health in the
                    course of my care at any time, without affecting my right to future care or treatment.<br />
                    <b>3.</b> I understand that I have the right to inspect all information obtained in the course of a tele-mental health
                    interaction and may receive copies of this information for a reasonable fee.<br />
                    <b>4.</b> I understand that no video and/or audio recordings of tele-mental health sessions will be made.<br />
                    <b>5.</b> I understand that a variety of alternative methods for the provision of mental health services may be
                    <b>a.</b> available to me, and that I may choose one or more of these at any time.<br />
                    <b>6.</b> I understand that an alternative method for the provision of mental health services may be used by my
                    <b>a.</b> mental health professional when deemed necessary.<br />
                    <b>7.</b> I understand that it is my duty to inform my mental health professional of any other healthcare providers involved
                    in my medical/ mental health care.<br />
                    <b>8.</b> I understand that I may expect the anticipated benefits from the use of tele-mental health in my care, but that no
                    results can be guaranteed or assured.<br />
                    <b>9.</b>I understand that Life Solutions South cannot ensure confidentiality at the site where the client is located and
                    when unapproved equipment software is used by the client, when tele-mental health procedures are not followed
                    by the client.<br />
                    <b>10.</b> I understand that Life Solutions South is not responsible for overages on client data usage plans, when Wi-Fi is not
                    used by the client.<br />
                    <b>11.</b> I understand that my mental health professional providing tele-mental health is a qualified mental health
                    professional with specialized training in the provision of distance mental health.<br />
                    <b>12.</b> I understand that Life Solutions South Headquarters is located at 2728 Euclid Avenue, Suite 400, Cleveland, OH
                    44115; phone number: 216-539-2410.<br />
                    <b>13.</b> I understand that in times of crisis, or as desired during business hours, I may reach my mental health professional
                    by business cell or desk phone.<br />
                    <b>14.</b> I understand that in times of crisis outside of normal work hours of my mental health professional I may call the
                    Mobile Crisis Hotline at 234-334-1880 or call 911.<br /> <br />
                    <b><center>Client Consent to the Use of Tele-Mental health</center></b>
                    I have read and understand the information provided above regarding tele-mental health, have discussed it with my mental
                    health professional as may be designated, and all of my questions have been answered to my satisfaction. I hereby give my
                    informed consent for the use of tele-therapy in my medical care. I hereby authorize Life Solutions South to use tele-mental
                    health in the course of my mental health diagnosis and treatment.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Client Signature: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Parent/Legal Guardian Signature: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}